
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { NAVIGATION_PAGES } from '@/types/enums';
import AppLazyImage from '../UI/AppLazyImage.vue';
import AppSkeletonMessage from './AppSkeletonMessage.vue';
import AppMessageInput from '@/components/UI/AppMessageInput.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    group: { type: Boolean, default: false },
    hideSkeletons: { type: Boolean, default: false },
  },
  components: {
    AppLazyImage,
    AppSkeletonMessage,
    AppMessageInput,
  },
  setup(props) {
    const route = useRoute();
    const mainStore = useMainStore();
    const backText = computed(() => route.meta.backText);

    const photoUrl = computed(() => {
      if (route.meta.navigationPage === NAVIGATION_PAGES.MESSAGES_GROUP_CHAT_ID || props.group) {
        // eslint-disable-next-line global-require
        return require('@/assets/img/mockup/Group.svg');
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    return {
      photoUrl,
      mainStore,
      backText,
    };
  },
});

